<template>
<div class="chapter">
<div class="inner_page">
<div class="body">
<section aria-labelledby="cont" epub:type="toc" role="doc-toc">
<p class="SP"> </p>
<header>
<h1 class="FMH" id="cont"><span aria-label="vii" id="pg_vii" role="doc-pagebreak">Contents</span></h1>
</header>
<ol class="toc">
<li class="CFMH" id="c_pre"><a href="#/xhtml/preface"><i>Preface</i></a></li>
<li class="CCTF" id="c_int"><a href="#/xhtml/introduction">Introduction</a></li>
<li class="CCT" id="c_ch1"><a href="#/xhtml/chapter1"><span class="ccn">1</span>    The Mission of Catholic Higher Education in the Age of the Corporatized University</a></li>
<li class="CCT" id="c_ch2"><span href="#/xhtml/chapter2" title="Link target outside of Sample"><span class="ccn">2</span>    Embodying Solidarity on Catholic Campuses: The Case of Worker Justice</span></li>
<li class="CCT" id="c_ch3"><span href="#/xhtml/chapter3" title="Link target outside of Sample"><span class="ccn">3</span>    Catholic Universities, the Right to Education, and the Option for the Poor: Recruiting, Admitting, and Retaining Economically Disadvantaged Students</span></li>
<li class="CCT" id="c_ch4"><span href="#/xhtml/chapter4" title="Link target outside of Sample"><span class="ccn">4</span>    Socially Responsible Investment, the Stewardship of University Resources, and Integral Ecology</span></li>
<li class="CCT" id="c_ch5"><span href="#/xhtml/chapter5" title="Link target outside of Sample"><span class="ccn">5</span>    Racial Inclusion and Justice at Catholic Colleges and Universities: From Tokenism to Participation</span></li>
<li class="CCT" id="c_ch6"><span href="#/xhtml/chapter6" title="Link target outside of Sample"><span class="ccn">6</span>    Gender and LGBTQ Equality in the University: A Challenge for CST in the Age of Corporatized Higher Education</span></li>
<li class="CCT1" id="c_epi"><span href="#/xhtml/epilogue" title="Link target outside of Sample">Epilogue</span></li>
<li class="CBMHF" id="c_app"><span href="#/xhtml/appendix" title="Link target outside of Sample"><i>Appendix: Embodying Catholic Social Teaching on Campus Sample Questionnaire</i></span></li>
<li class="CBMH" id="c_ack"><span href="#/xhtml/acknowledgments" title="Link target outside of Sample"><i>Acknowledgments</i></span></li>
<li class="CBMH" id="c_not"><span href="#/xhtml/notes" title="Link target outside of Sample"><i>Notes</i></span></li>
<li class="CBMH" id="c_ind"><span href="#/xhtml/index" title="Link target outside of Sample"><i>Index</i></span></li>
</ol>
</section>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// contents.vue?0283e6a2